// extracted by mini-css-extract-plugin
export default {"primary":"#00a499","secondary":"#ec6e33"};